<template>
  <div class="wrapper layout-wrapper">
    <popupMessage
      v-if="this.$store.state.popupPayload.isModalOpen"
      :msg="this.$store.state.popupPayload.popupMsg"
    />

    <Navigation />
    <div class="layout">
      <router-view />
    </div>
    <footer-layout />
  </div>
</template>
<style>
html,
body {
  background: #fff;
}
.layout-wrapper {
  position: relative;
}
.layout {
  padding-top: 80px;
}
body.modal-open {
  overflow: hidden;
}
button,
input,
textarea,
select {
  font-family: "Pretendard Variable", Pretendard, -apple-system,
    BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI",
    "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Font Awesome 5 Free",
    "Font Awesome 5 Pro", sans-serif;
}

.wrapper {
  font-family: "Pretendard Variable", Pretendard, -apple-system,
    BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI",
    "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Font Awesome 5 Free",
    "Font Awesome 5 Pro", sans-serif;
}
</style>

<script>
import HeaderLayout from "@/components/common/header.layout.vue";
import Navigation from "@/components/common/Navigation";
import FooterLayout from "@/components/common/footer.layout";
import popupMessage from "@/components/modal/popupMessage/layout";

export default {
  name: "Layout",
  components: {
    HeaderLayout,
    FooterLayout,
    popupMessage,
    Navigation
  }
};
</script>
